export const enum FeatureToggleName {
  MPM_ADMIN_DEBUGMENU = 'MPM_ADMIN_DEBUGMENU',
  MPM_SECURITY_OTP = 'MPM_SECURITY_OTP',
  MPM_ACTEVENTE_VISIBILITY = 'MPM_ACTEVENTE_VISIBILITY',
  MPM_PROPRIETE_VISIBILITY = 'MPM_PROPRIETE_VISIBILITY',
  MPM_OFFREACHAT_VISIBILITY = 'MPM_OFFREACHAT_VISIBILITY',
  MPM_EMMENAGEMENT_VISIBILITY = 'MPM_EMMENAGEMENT_VISIBILITY',
  MPM_OCTROI_VISIBILITY = 'MPM_OCTROI_VISIBILITY',
  MPM_ASSURANCEHABITATION_VISIBILITY = 'MPM_ASSURANCEHABITATION_VISIBILITY',
  MPM_ASSURANCEPRET_VISIBILITY = 'MPM_ASSURANCEPRET_VISIBILITY',
  MPM_PREAUT_TAUX_VISIBILITY = 'MPM_PREAUT_TAUX_VISIBILITY',
  MPM_CLICKTOCALLBACK_VISIBILITY = 'MPM_CLICKTOCALLBACK_VISIBILITY',
  MPM_ASSURANCE_SOUMISSION = 'MPM_ASSURANCE_SOUMISSION',
  MPM_RENDEZVOUS_LOCALISATION = 'MPM_RENDEZVOUS_LOCALISATION',
  MPM_PREAUT_VERSION = 'MPM_PREAUT_VERSION',
  MPM_PROPRIETE_PHOTO_ENABLED = 'MPM_PROPRIETE_PHOTO_ENABLED',
  MPM_CAPACITE_VERSION = 'MPM_CAPACITE_VERSION',
  MPM_OFFRE_PROMO_ENABLED = 'MPM_OFFRE_PROMO_ENABLED',
  MPM_PREAUT_IMPL_VERSION = 'MPM_PREAUT_IMPL_VERSION'
}

export const MPM_ADMIN_DEBUGMENU = {
  On: { name: FeatureToggleName.MPM_ADMIN_DEBUGMENU, value: 'on' },
  Off: { name: FeatureToggleName.MPM_ADMIN_DEBUGMENU, value: 'off' }
};

export const MPM_SECURITY_OTP = {
  On: { name: FeatureToggleName.MPM_SECURITY_OTP, value: 'on' },
  Off: { name: FeatureToggleName.MPM_SECURITY_OTP, value: 'off' }
};

export const MPM_ACTEVENTE_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_ACTEVENTE_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_ACTEVENTE_VISIBILITY, value: 'disabled' }
};

export const MPM_PROPRIETE_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_PROPRIETE_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_PROPRIETE_VISIBILITY, value: 'disabled' }
};

export const MPM_OFFREACHAT_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_OFFREACHAT_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_OFFREACHAT_VISIBILITY, value: 'disabled' }
};

export const MPM_EMMENAGEMENT_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_EMMENAGEMENT_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_EMMENAGEMENT_VISIBILITY, value: 'disabled' }
};

export const MPM_OCTROI_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_OCTROI_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_OCTROI_VISIBILITY, value: 'disabled' }
};

export const MPM_ASSURANCEHABITATION_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_ASSURANCEHABITATION_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_ASSURANCEHABITATION_VISIBILITY, value: 'disabled' }
};

export const MPM_ASSURANCEPRET_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_ASSURANCEPRET_VISIBILITY, value: 'on' },
  Disabled: { name: FeatureToggleName.MPM_ASSURANCEPRET_VISIBILITY, value: 'disabled' }
};

export const MPM_PREAUT_TAUX_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_PREAUT_TAUX_VISIBILITY, value: 'on' },
  Hidden: { name: FeatureToggleName.MPM_PREAUT_TAUX_VISIBILITY, value: 'hidden' }
};

export const MPM_CLICKTOCALLBACK_VISIBILITY = {
  On: { name: FeatureToggleName.MPM_CLICKTOCALLBACK_VISIBILITY, value: 'on' },
  Hidden: { name: FeatureToggleName.MPM_CLICKTOCALLBACK_VISIBILITY, value: 'hidden' }
};

export const MPM_ASSURANCE_SOUMISSION = {
  DAG: { name: FeatureToggleName.MPM_ASSURANCE_SOUMISSION, value: 'dag' },
  Telephone: { name: FeatureToggleName.MPM_ASSURANCE_SOUMISSION, value: 'telephone' }
};

export const MPM_RENDEZVOUS_LOCALISATION = {
  ServiceRepresentant: { name: FeatureToggleName.MPM_RENDEZVOUS_LOCALISATION, value: 'servicerepresentant' },
  CodePostal: { name: FeatureToggleName.MPM_RENDEZVOUS_LOCALISATION, value: 'codepostal' }
};

export const MPM_PREAUT_VERSION = {
  Disabled: { name: FeatureToggleName.MPM_PREAUT_VERSION, value: 'disabled' },
  Dsd: { name: FeatureToggleName.MPM_PREAUT_VERSION, value: 'dsd' }
};

export const MPM_PROPRIETE_PHOTO_ENABLED = {
  On: { name: FeatureToggleName.MPM_PROPRIETE_PHOTO_ENABLED, value: 'on' },
  Off: { name: FeatureToggleName.MPM_PROPRIETE_PHOTO_ENABLED, value: 'off' }
};

export const MPM_CAPACITE_VERSION = {
  Disabled: { name: FeatureToggleName.MPM_CAPACITE_VERSION, value: 'disabled' },
  DSD: { name: FeatureToggleName.MPM_CAPACITE_VERSION, value: 'dsd' },
  Experimente: { name: FeatureToggleName.MPM_CAPACITE_VERSION, value: 'experimente' }
};

export const MPM_OFFRE_PROMO_ENABLED = {
  On: { name: FeatureToggleName.MPM_OFFRE_PROMO_ENABLED, value: 'on' },
  Off: { name: FeatureToggleName.MPM_OFFRE_PROMO_ENABLED, value: 'off' }
};

export const MPM_PREAUT_IMPL_VERSION = {
  Simplifiee: { name: FeatureToggleName.MPM_PREAUT_IMPL_VERSION, value: 'Simplifiee' },
  GarantieTaux: { name: FeatureToggleName.MPM_PREAUT_IMPL_VERSION, value: 'GarantieTaux' }
};

export const DEFAULT_TOGGLES_CONFIG = [
  MPM_ADMIN_DEBUGMENU.Off,
  MPM_SECURITY_OTP.On,
  MPM_PROPRIETE_VISIBILITY.On,
  MPM_ACTEVENTE_VISIBILITY.On,
  MPM_OFFREACHAT_VISIBILITY.On,
  MPM_EMMENAGEMENT_VISIBILITY.On,
  MPM_OCTROI_VISIBILITY.On,
  MPM_ASSURANCEHABITATION_VISIBILITY.On,
  MPM_ASSURANCEPRET_VISIBILITY.On,
  MPM_PREAUT_TAUX_VISIBILITY.On,
  MPM_CLICKTOCALLBACK_VISIBILITY.On,
  MPM_ASSURANCE_SOUMISSION.Telephone,
  MPM_RENDEZVOUS_LOCALISATION.CodePostal,
  MPM_PREAUT_VERSION.Disabled,
  MPM_PROPRIETE_PHOTO_ENABLED.On,
  MPM_CAPACITE_VERSION.DSD,
  MPM_OFFRE_PROMO_ENABLED.Off,
  MPM_PREAUT_IMPL_VERSION.Simplifiee
];
